const en = {
  // Common
  "app.name": "GrowthRIQ",
  "common.loading": "Loading...",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.delete": "Delete",
  "common.edit": "Edit",
  "common.close": "Close",
  "common.back": "Back",
  "common.next": "Next",
  "common.previous": "Previous",
  "common.submit": "Submit",
  "common.search": "Search",
  "common.yes": "Yes",
  "common.no": "No",
  "common.or": "or",

  // Nav
  "nav.pricing": "Pricing",
  "nav.dashboard": "Dashboard",
  "nav.login": "Login",
  "nav.register": "Get Started",
  "nav.companies": "Companies",
  "nav.advisor": "AI Advisor",
  "nav.admin": "Admin",
  "nav.signout": "Sign Out",
  "nav.tools": "Tools",
  "nav.blog": "Blog",
  "footer.tools": "Free tools",
  "footer.blog": "Blog",
  "footer.pricing": "Pricing",
  "footer.kvkk": "Privacy (KVKK)",
  "footer.terms": "Terms",
  "footer.cookies": "Cookies",
  "footer.mesafeli": "Distance Sales",
  "footer.onBilg": "Pre-info Form",

  // Landing
  "landing.hero.label": "AI-POWERED GROWTH INTELLIGENCE",
  "landing.hero.title": "Measure first, grow next.",
  "landing.hero.subtitle": "Transform Your E-Commerce & E-Export Strategy",
  "landing.hero.description": "Measure first, then grow. GrowthRIQ unifies your AI visibility, competitor analysis, store audit, pricing engine and digital maturity diagnostic into a single growth hub. Concrete roadmap in 20 minutes — instant score, evidence-based recommendations.",
  "landing.hero.cta.primary": "Start Free Assessment",
  "landing.hero.cta.demo": "See a Sample Report",
  "landing.hero.cta.secondary": "View Pricing",
  "landing.hero.trust.1": "No credit card needed",
  "landing.hero.trust.2": "5-minute setup",
  "landing.hero.trust.3": "TR & EN supported",
  "landing.stats.1.value": "100+",
  "landing.stats.1.label": "Strategic Questions",
  "landing.stats.2.value": "10",
  "landing.stats.2.label": "Analysis Categories",
  "landing.stats.3.value": "<2min",
  "landing.stats.3.label": "To First Score",
  "landing.stats.4.value": "GPT-5.2",
  "landing.stats.4.label": "AI Model",
  "landing.how.label": "HOW IT WORKS",
  "landing.how.title": "Three Steps to Your Strategy",
  "landing.how.1.title": "Define Your Problem",
  "landing.how.1.desc": "Tell us your sector and goal. GrowthRIQ recommends the right tool: AI visibility, competitor analysis, store audit, or the full digital maturity diagnostic.",
  "landing.how.2.title": "Use the Right Tool",
  "landing.how.2.desc": "Get instant insights from 5 free tools, or run the 87-question digital maturity diagnostic for a 360° report. 2-20 minutes.",
  "landing.how.3.title": "Execute the Action Plan",
  "landing.how.3.desc": "Prioritized 30/60/90-day action plan, SWOT/GAP analysis, and AI advisor. Instantly.",
  "landing.pricing.label": "PRICING",
  "landing.pricing.title": "Packages That Scale With Your Growth",
  "landing.pricing.free.name": "Free",
  "landing.pricing.free.price": "$0",
  "landing.pricing.free.desc": "Your first assessment is free. Score + overview report.",
  "landing.pricing.basic.name": "E-Commerce Basic",
  "landing.pricing.basic.price": "$99",
  "landing.pricing.basic.desc": "Deep-dive assessment, SWOT, AI chat, PDF report.",
  "landing.pricing.advanced.name": "E-Export Advanced",
  "landing.pricing.advanced.price": "$399",
  "landing.pricing.advanced.desc": "All features, unlimited assessments, GAP, full roadmap.",
  "landing.pricing.see_all": "See All Packages",
  "landing.faq.label": "FAQ",
  "landing.faq.title": "Questions You Might Have",
  "landing.faq.1.q": "Does this replace a strategy consultant?",
  "landing.faq.1.a": "We automate Big-4 consulting methodologies with AI. For core strategic insights — yes. For complex M&A or restructuring, a consultant may still be needed.",
  "landing.faq.2.q": "How long does an assessment take?",
  "landing.faq.2.a": "Free assessment: 5-10 minutes. Advanced packages: 20-30 minutes with 100+ detailed questions.",
  "landing.faq.3.q": "Do I need technical knowledge?",
  "landing.faq.3.a": "No. Questions are business-focused and jargon-free. Marketing, operations, or CEO-level staff can answer them.",
  "landing.faq.4.q": "Is my data secure?",
  "landing.faq.4.a": "All data is encrypted at rest, accessible only to your organization. Never shared with third parties. GDPR/KVKK compliant.",
  "landing.faq.5.q": "Can I cancel anytime?",
  "landing.faq.5.a": "Yes. Cancel in one click from your dashboard. 14-day refund policy applies.",
  "landing.faq.6.q": "Does the AI understand my industry?",
  "landing.faq.6.a": "Yes. The GPT-5.2 engine is trained on 50+ industries. Reports include industry-specific benchmarks and tailored recommendations.",
  "landing.seo.title": "GrowthRIQ — AI-Powered E-Commerce & E-Export Growth Intelligence",
  "landing.seo.description": "Assess your e-commerce and e-export maturity with AI. Get strategic SWOT, GAP analysis, and a prioritized action roadmap. First assessment free.",
  "landing.features.label": "PLATFORM TOOLS",
  "landing.features.title": "6 Powerful Tools, One Growth Hub",
  "landing.feature.1.title": "AI Visibility Checkup",
  "landing.feature.1.desc": "Measure how visible your brand is in AI engines like ChatGPT, Perplexity, and Gemini. (FREE)",
  "landing.feature.2.title": "Competitor Radar",
  "landing.feature.2.desc": "Benchmark your Trendyol, Amazon, Shopify rivals anonymously. Spot gaps and opportunities. (FREE)",
  "landing.feature.3.title": "Report Analytics",
  "landing.feature.3.desc": "Upload your marketplace seller report; AI interprets metrics and surfaces alerts. (FREE)",
  "landing.feature.4.title": "Pricing Engine",
  "landing.feature.4.desc": "Cost, commission and target margin in — recommended sell price per platform out, instantly. (FREE)",
  "landing.feature.5.title": "Store Audit",
  "landing.feature.5.desc": "Analyze your own site or Trendyol/Hepsiburada storefront from a URL: tech, SEO and content scoring + quick wins.",
  "landing.feature.6.title": "Digital Maturity Diagnostic",
  "landing.feature.6.desc": "Deep 87-question diagnostic + SWOT/GAP analysis + 30/60/90-day strategic roadmap + AI advisor.",
  "landing.benefits.label": "WHY GROWTHRIQ",
  "landing.benefits.title": "Data-Driven Growth Decisions",
  "landing.benefit.1": "Identify critical gaps in your digital strategy",
  "landing.benefit.2": "Get actionable 30-90 day roadmaps",
  "landing.benefit.3": "Benchmark against industry standards",
  "landing.benefit.4": "Track progress over time",
  "landing.benefit.5": "Access expert AI-powered insights",
  "landing.cta.title": "Ready to Accelerate Your Growth?",
  "landing.cta.description": "Join hundreds of businesses that have transformed their digital strategy with GrowthRIQ.",
  "landing.cta.button": "Start Your Free Assessment",
  "landing.footer": "© 2026 GrowthRIQ. AI-Powered E-Commerce Intelligence Platform.",

  // Login
  "login.title": "Welcome back",
  "login.subtitle": "Sign in to access your dashboard and assessments.",
  "login.email": "Email",
  "login.email.placeholder": "you@company.com",
  "login.password": "Password",
  "login.submit": "Sign In",
  "login.submitting": "Signing in...",
  "login.no_account": "Don't have an account?",
  "login.create_one": "Create one",
  "login.success": "Login successful",
  "login.error": "Invalid email or password",
  "login.stat": "of companies report improved strategic clarity after using GrowthRIQ assessments.",

  // Register
  "register.title": "Create your account",
  "register.subtitle": "Get started with your free assessment.",
  "register.first_name": "First Name",
  "register.last_name": "Last Name",
  "register.email": "Email",
  "register.organization": "Organization Name",
  "register.organization.placeholder": "Your Company Inc.",
  "register.password": "Password",
  "register.submit": "Create Account",
  "register.submitting": "Creating account...",
  "register.has_account": "Already have an account?",
  "register.sign_in": "Sign in",
  "register.success": "Account created successfully",
  "register.error": "Registration failed",
  "register.error.email_required": "Email address is required",
  "register.error.email_invalid": "Please enter a valid email address",
  "register.error.password_short": "Password must be at least 6 characters",
  "register.error.name_required": "First name and last name are required",
  "register.error.org_required": "Company name is required",
  "register.benefit.1": "Free assessment to evaluate your digital maturity",
  "register.benefit.2": "AI-powered strategic insights and recommendations",
  "register.benefit.3": "Actionable 30-90 day roadmaps",
  "register.benefit.4": "Expert AI advisor available 24/7",
  "register.panel.title": "Start your growth journey today",

  // Dashboard
  "dashboard.welcome": "Welcome back, {name}",
  "dashboard.subtitle": "{org} Dashboard",
  "dashboard.subtitle_default": "Your Growth Intelligence Dashboard",
  "dashboard.stats.companies": "COMPANIES",
  "dashboard.stats.assessments": "ASSESSMENTS",
  "dashboard.stats.completed": "COMPLETED",
  "dashboard.stats.avg_score": "AVG SCORE",
  "dashboard.quick_actions": "Quick Actions",
  "dashboard.action.add_company": "Add Company",
  "dashboard.action.chat_advisor": "Chat with AI Advisor",
  "dashboard.action.upgrade": "Upgrade Plan",
  "dashboard.recent": "Recent Assessments",
  "dashboard.view_all": "View All",
  "dashboard.no_assessments": "No assessments yet",
  "dashboard.start_first": "Start Your First Assessment",
  "dashboard.view_report": "View Report",
  "dashboard.continue": "Continue",

  // Companies
  "companies.title": "Your Companies",
  "companies.subtitle": "Manage your companies and start new assessments.",
  "companies.add": "Add Company",
  "companies.no_companies": "No companies yet",
  "companies.no_companies_desc": "Add your first company to start assessments.",
  "companies.add_first": "Add Your First Company",
  "companies.dialog.title": "Add New Company",
  "companies.dialog.subtitle": "Enter company details.",
  "companies.field.name": "Company Name",
  "companies.field.industry": "Industry",
  "companies.field.country": "Country",
  "companies.field.size": "Company Size",
  "companies.field.website": "Website",
  "companies.field.model": "Business Model",
  "companies.field.annual_revenue": "Annual Revenue",
  "companies.field.select": "Select",
  "companies.creating": "Creating...",
  "companies.create": "Create Company",
  "companies.start_assessment": "Start Assessment",
  "companies.assessments_count": "{count} Assessments",
  "companies.assessment.dialog.title": "New Assessment",
  "companies.assessment.dialog.subtitle": "Select assessment type and level.",
  "companies.assessment.type": "Assessment Type",
  "companies.assessment.level": "Level",
  "companies.assessment.starting": "Starting...",
  "companies.assessment.start": "Start Assessment",

  // Industries
  "industry.retail": "Retail & E-Commerce",
  "industry.fashion": "Fashion & Apparel",
  "industry.electronics": "Electronics",
  "industry.food": "Food & Beverage",
  "industry.health": "Health & Beauty",
  "industry.home": "Home & Garden",
  "industry.sports": "Sports & Outdoors",
  "industry.automotive": "Automotive",
  "industry.b2b": "B2B & Industrial",
  "industry.other": "Other",

  // Countries
  "country.us": "United States",
  "country.uk": "United Kingdom",
  "country.de": "Germany",
  "country.fr": "France",
  "country.tr": "Turkey",
  "country.nl": "Netherlands",
  "country.es": "Spain",
  "country.it": "Italy",
  "country.ca": "Canada",
  "country.au": "Australia",
  "country.other": "Other",

  // Business Models
  "model.b2c": "B2C (Consumer)",
  "model.b2b": "B2B (Business)",
  "model.b2b2c": "B2B2C (Hybrid)",
  "model.d2c": "D2C (Direct to Consumer)",
  "model.marketplace": "Marketplace",

  // Company Sizes
  "size.1-10": "1-10 Employees",
  "size.11-50": "11-50 Employees",
  "size.51-200": "51-200 Employees",
  "size.201-500": "201-500 Employees",
  "size.500+": "500+ Employees",

  // Assessment Types
  "assessment.type.ecommerce": "E-Commerce",
  "assessment.type.eexport": "E-Export",
  "assessment.level.free": "Free",
  "assessment.level.basic": "Basic",
  "assessment.level.advanced": "Advanced",

  // Assessment Wizard
  "wizard.title": "Assessment",
  "wizard.loading": "Loading assessment...",
  "wizard.question": "Question {current} / {total}",
  "wizard.category": "Category: {name}",
  "wizard.critical": "Critical Question",
  "wizard.previous": "Previous",
  "wizard.next": "Next",
  "wizard.submit": "Complete Assessment",
  "wizard.submitting": "Submitting...",
  "wizard.select_answer": "Please select an answer",
  "wizard.submit_error": "Could not save the answer. Please try again.",
  "wizard.submit_confirm": "Are you sure you want to complete the assessment?",
  "wizard.completed": "Assessment completed!",
  "wizard.report_pending": "Report is being generated — it will be ready in a moment.",
  "wizard.complete_error": "Could not complete the assessment. Please try again.",
  "report.generating.title": "Your AI report is being generated...",
  "report.generating.body": "Your scores are ready! The detailed analysis (SWOT, GAP, Roadmap) will appear here in 30-90 seconds. You can wait — the page will refresh automatically.",

  // Report
  "report.title": "Assessment Report",
  "report.back": "Back to Companies",
  "report.download": "Download PDF",
  "report.downloading": "Downloading...",
  "report.chat_advisor": "Chat with Advisor",
  "report.tab.overview": "Overview",
  "report.tab.categories": "Category Analysis",
  "report.tab.swot": "SWOT Analysis",
  "report.tab.roadmap": "Action Roadmap",
  "report.tab.gap": "GAP Analysis",
  "report.overall_score": "Overall Score",
  "report.executive_summary": "Executive Summary",
  "report.category_scores": "Category Scores",
  "report.strengths": "Strengths",
  "report.weaknesses": "Weaknesses",
  "report.opportunities": "Opportunities",
  "report.threats": "Threats",
  "report.roadmap.immediate": "Immediate (0-30 Days)",
  "report.roadmap.short_term": "Short Term (30-60 Days)",
  "report.roadmap.medium_term": "Medium Term (60-90 Days)",
  "report.gap.current_state": "CURRENT STATE",
  "report.gap.desired_state": "DESIRED STATE",
  "report.gap.description": "Gap Description",
  "report.gap.impact": "Business Impact",
  "report.gap.actions": "Closing Actions",
  "report.gap.empty": "GAP analysis will be available after AI report generation.",
  "report.no_data": "No data available",
  "report.generating": "Generating report...",
  "report.generate": "Generate Report",
  "report.not_found": "Report not found",
  "report.pdf_not_available": "PDF not available. Please regenerate the report.",
  "report.pdf_success": "PDF downloaded successfully",

  // Pricing
  "pricing.label": "PRICING",
  "pricing.title": "Choose Your Growth Package",
  "pricing.subtitle": "Start with a free assessment or unlock advanced AI-powered insights with our premium packages.",
  "pricing.popular": "MOST POPULAR",
  "pricing.one_time": "one-time",
  "pricing.coupon.placeholder": "Coupon code",
  "pricing.coupon.apply": "Apply",
  "pricing.coupon.applied": "Coupon applied",
  "pricing.coupon.invalid": "Invalid coupon",
  "pricing.coupon.with_code": "with code",
  "pricing.coupon.free_label": "FREE with coupon",
  "pricing.processing": "Processing...",
  "pricing.start_free": "Start Free",
  "pricing.get_started": "Get Started",
  "pricing.whats_included": "What's Included",
  "pricing.feature.ai_analysis": "AI-Powered Analysis",
  "pricing.feature.ai_analysis.desc": "GPT-5.2 powered insights that identify gaps and opportunities in your digital strategy.",
  "pricing.feature.swot": "SWOT Analysis",
  "pricing.feature.swot.desc": "Comprehensive strengths, weaknesses, opportunities, and threats analysis.",
  "pricing.feature.roadmap": "Action Roadmap",
  "pricing.feature.roadmap.desc": "Prioritized 30-90 day action plan with specific recommendations.",
  "pricing.feature.benchmark": "Category Benchmarking",
  "pricing.feature.benchmark.desc": "Compare your performance across 10 key areas against industry standards.",
  "pricing.feature.advisor": "AI Chat Advisor",
  "pricing.feature.advisor.desc": "Get answers to specific questions about your results and strategy.",
  "pricing.feature.pdf": "PDF Reports",
  "pricing.feature.pdf.desc": "Download professional reports to share with your team.",
  "pricing.cta.title": "Ready to accelerate your growth?",
  "pricing.cta.desc": "Start with a free assessment and see how GrowthRIQ can transform your digital strategy.",
  "pricing.cta.button": "Get Started Free",
  "pricing.footer": "© 2026 GrowthRIQ. All rights reserved.",

  // Chat Advisor
  "chat.title": "AI Growth Advisor",
  "chat.description": "Ask me anything about your assessment results, e-commerce strategy, or digital transformation best practices.",
  "chat.context": "Context:",
  "chat.general": "General (No assessment)",
  "chat.input_placeholder": "Ask about your assessment results, strategy recommendations, or industry best practices...",
  "chat.suggested.1": "What are my biggest areas for improvement?",
  "chat.suggested.2": "How can I improve my digital marketing score?",
  "chat.suggested.3": "What quick wins can I implement this week?",
  "chat.suggested.4": "Compare my scores to industry benchmarks",
  "chat.error": "Failed to get response",

  // Admin
  "admin.title": "Admin Panel",
  "admin.subtitle": "Manage users, organizations, and AI prompts",
  "admin.users": "Users",
  "admin.organizations": "Organizations",
  "admin.prompts": "AI Prompts",
  "admin.table.id": "ID",
  "admin.table.email": "Email",
  "admin.table.name": "Name",
  "admin.table.role": "Role",
  "admin.table.organization": "Organization",
  "admin.table.admin": "Admin",
  "admin.table.plan": "Plan",
  "admin.table.users": "Users",
  "admin.table.companies": "Companies",
  "admin.table.created": "Created",
  "admin.table.type": "Type",
  "admin.table.preview": "Preview",
  "admin.table.active": "Active",
  "admin.table.inactive": "Inactive",

  // Blog admin
  "admin.blog": "Blog",
  "admin.blog.new": "New Post",
  "admin.blog.edit": "Edit",
  "admin.blog.delete": "Delete",
  "admin.blog.preview": "Preview",
  "admin.blog.confirmDelete": "Are you sure you want to delete this post?",
  "admin.blog.deleted": "Post deleted",
  "admin.blog.saved": "Post saved",
  "admin.blog.table.slug": "Slug",
  "admin.blog.table.title": "Title",
  "admin.blog.table.status": "Status",
  "admin.blog.table.views": "Views",
  "admin.blog.table.date": "Date",
  "admin.blog.table.actions": "Actions",
  "admin.blog.status.published": "Published",
  "admin.blog.status.draft": "Draft",
  "admin.blog.form.title": "Blog Post",
  "admin.blog.form.slug": "URL Slug (e.g. e-export-guide)",
  "admin.blog.form.slugHelp": "Lowercase letters, digits, hyphens only. Do not change after publishing.",
  "admin.blog.form.titleTr": "Title (Turkish)",
  "admin.blog.form.titleEn": "Title (English)",
  "admin.blog.form.excerptTr": "Excerpt (Turkish)",
  "admin.blog.form.excerptEn": "Excerpt (English)",
  "admin.blog.form.contentTr": "Markdown Content (Turkish)",
  "admin.blog.form.contentEn": "Markdown Content (English)",
  "admin.blog.form.metaTr": "Meta Description (Turkish, 150-160 chars)",
  "admin.blog.form.metaEn": "Meta Description (English, 150-160 chars)",
  "admin.blog.form.coverImage": "Cover Image URL",
  "admin.blog.form.tags": "Tags (comma separated)",
  "admin.blog.form.author": "Author",
  "admin.blog.form.published": "Published",
  "admin.blog.form.previewTab": "Markdown Preview",
  "admin.blog.form.save": "Save",
  "admin.blog.form.cancel": "Cancel",
  "admin.blog.form.required": "Please fill required fields",
  "admin.blog.empty": "No posts yet. Create your first one.",

  // Blog AI draft
  "admin.blog.ai.button": "AI Draft",
  "admin.blog.ai.title": "AI Blog Draft Generator",
  "admin.blog.ai.description": "Enter a short topic and GPT-5.2 will generate an SEO-friendly bilingual (TR+EN) markdown draft with meta and slug. Review and edit before saving.",
  "admin.blog.form.dialogHelp": "Use the markdown editor to create or edit your post. Switch between TR and EN tabs to enter content in both languages.",
  "admin.blog.ai.topicLabel": "Topic / Post Title",
  "admin.blog.ai.topicPlaceholder": "e.g. Shopify vs WooCommerce 2026 comparison",
  "admin.blog.ai.keywordsLabel": "Keywords (optional, comma-separated)",
  "admin.blog.ai.help": "Generation takes 20-40 seconds. Draft opens automatically as unpublished.",
  "admin.blog.ai.generate": "Generate",
  "admin.blog.ai.generating": "Generating...",
  "admin.blog.ai.generated": "AI draft generated — please review and save",
  "admin.blog.ai.failed": "AI draft generation failed",
  "admin.blog.ai.topicRequired": "Topic must be at least 3 characters",

  // Branding settings
  "branding.title": "Branded PDF Reports",
  "branding.subtitle": "Add your own logo, color and footer to reports (white-label)",
  "branding.tab": "Brand",
  "branding.brand_name": "Brand Name",
  "branding.brand_name.help": "Appears on the report cover and back cover. Leave blank to use 'GrowthRIQ'.",
  "branding.logo_url": "Logo URL",
  "branding.logo_url.help": "Recommended: horizontal, transparent-bg PNG (max 260×70px). Must be a public URL.",
  "branding.primary_color": "Primary Color (Hex)",
  "branding.primary_color.help": "Used on report headings and accents. e.g. #1E40AF",
  "branding.footer_text": "Footer Text",
  "branding.footer_text.help": "Shown on the back cover. Copyright, confidentiality notice, etc.",
  "branding.save": "Save",
  "branding.saved": "Brand settings saved",
  "branding.reset": "Reset to default",
  "branding.preview": "Preview",
  "branding.invalidColor": "Invalid hex color. e.g. #1E40AF",

  // Coupons admin
  "admin.coupons": "Coupons",
  "admin.coupons.new": "New Coupon",
  "admin.coupons.edit": "Edit",
  "admin.coupons.delete": "Delete",
  "admin.coupons.cancel": "Cancel",
  "admin.coupons.save": "Save",
  "admin.coupons.saved": "Coupon saved",
  "admin.coupons.deleted": "Coupon deleted",
  "admin.coupons.confirm_delete": "Are you sure? Existing redemption records will be removed.",
  "admin.coupons.empty": "No coupons yet. Create your first one.",
  "admin.coupons.code": "Code",
  "admin.coupons.code_required": "Code must be at least 2 characters",
  "admin.coupons.description": "Description",
  "admin.coupons.discount": "Discount",
  "admin.coupons.discount_type": "Discount Type",
  "admin.coupons.discount_value": "Value",
  "admin.coupons.type.percent": "Percent (%)",
  "admin.coupons.type.fixed": "Fixed USD",
  "admin.coupons.type.free": "Fully Free",
  "admin.coupons.free": "FREE",
  "admin.coupons.packages": "Packages",
  "admin.coupons.all_packages": "All packages",
  "admin.coupons.applicable_packages": "Applicable Packages",
  "admin.coupons.packages_help": "If none selected, the coupon applies to all packages.",
  "admin.coupons.usage": "Usage",
  "admin.coupons.max_uses": "Max Uses",
  "admin.coupons.unlimited": "Unlimited",
  "admin.coupons.expires": "Expires",
  "admin.coupons.expires_at": "Expiration Date",
  "admin.coupons.status": "Status",
  "admin.coupons.active": "Active",
  "admin.coupons.inactive": "Inactive",
  "admin.coupons.actions": "Actions",
  "admin.coupons.percent_range": "Percent must be 0-100",

  // Statuses
  "status.completed": "completed",
  "status.in_progress": "in progress",
  "status.draft": "draft",

  // Password Reset
  "reset.title": "Reset Password",
  "reset.subtitle": "Enter your email address and we'll send you a reset link.",
  "reset.email": "Email",
  "reset.submit": "Send Reset Link",
  "reset.submitting": "Sending...",
  "reset.success": "Reset link sent",
  "reset.new_password": "New Password",
  "reset.confirm_submit": "Reset Password",
  "reset.confirm_success": "Password reset successfully",
  "reset.back_login": "Back to login",
  "reset.check_email": "If this email is registered, a password reset link has been sent. Please check your inbox.",
  "login.forgot_password": "Forgot your password?",

  // Plan
  "plan.title": "Your Current Plan",
  "plan.usage": "Usage",
  "plan.assessments": "Assessments",
  "plan.companies": "Companies",
  "plan.upgrade": "Upgrade Plan",
  "plan.of": "/",

  // Tools — hub
  "tools.nav": "Tools",
  "tools.hub.badge": "4 free tools • No signup required",
  "tools.hub.title.line1": "E-commerce growth tools,",
  "tools.hub.title.highlight": "one-click AI",
  "tools.hub.title.line2": "powered.",
  "tools.hub.subtitle": "AI visibility, competitor analysis, performance reports and pricing engine — all under one roof. Try without signing up; for the full experience",
  "tools.hub.subtitle.cta": "create a GrowthRIQ account",
  "tools.hub.upsell.title": "Ready for a deeper analysis beyond the tools?",
  "tools.hub.upsell.body": "87-question digital maturity diagnostic + AI strategic report + 30/60/90-day action plan.",
  "tools.hub.upsell.cta": "Start free assessment",
  "tools.cards.geo.badge": "AI",
  "tools.cards.geo.title": "AI Visibility Checkup",
  "tools.cards.geo.desc": "Is your brand visible in ChatGPT, Perplexity, and Gemini? Find out in 5 minutes.",
  "tools.cards.geo.cta": "Free analysis",
  "tools.cards.rakip.badge": "AI",
  "tools.cards.rakip.title": "Competitor Radar",
  "tools.cards.rakip.desc": "Anonymously benchmark your Trendyol, Amazon, Shopify rivals. Find gaps and opportunities.",
  "tools.cards.rakip.cta": "Compare my rivals",
  "tools.cards.rapor.badge": "AI",
  "tools.cards.rapor.title": "Report Analytics",
  "tools.cards.rapor.desc": "Upload a report from your marketplace seller panel; AI interprets it for you.",
  "tools.cards.rapor.cta": "Upload my report",
  "tools.cards.fiyat.badge": "Calculator",
  "tools.cards.fiyat.title": "Pricing Engine",
  "tools.cards.fiyat.desc": "Enter cost, commission and target margin; instantly get recommended selling prices per platform.",
  "tools.cards.fiyat.cta": "Start calculator",

  // Tools — shared layout
  "tools.layout.back": "All tools",
  "tools.upsell.deeper": "Want a deeper analysis?",
  "tools.upsell.deeper.body": "87-question growth assessment + AI report + action plan.",
  "tools.upsell.deeper.cta": "Open free account",

  // Tools — email capture
  "tools.capture.title": "Email the result to me",
  "tools.capture.desc": "We'll save your result and send a reference copy to your inbox. No ads — just your report.",
  "tools.capture.placeholder": "you@yourcompany.com",
  "tools.capture.submit": "Send result",
  "tools.capture.sending": "Sending...",
  "tools.capture.marketing": "I agree to receive 1 growth newsletter per month (unsubscribe anytime).",
  "tools.capture.invalid": "Enter a valid email address",
  "tools.capture.success.delivered": "Your result has been emailed",
  "tools.capture.success.queued": "We saved your result",
  "tools.capture.success.title": "Thank you!",
  "tools.capture.success.delivered_body": "We've emailed a summary to {email}. Don't forget to check your spam folder.",
  "tools.capture.success.delivered_marketing": "Our monthly growth tips are on the way.",
  "tools.capture.success.queued_body": "We saved your result for {email}. Our email delivery service will be active in a few days.",
  "tools.capture.error": "Could not send email",
  "tools.capture.coupon.title": "🎁 Welcome gift: 15% off, valid 30 days",
  "tools.capture.coupon.hint": "Paste this code at checkout. Valid on all packages.",

  // Pricing — legal consent
  "pricing.legal.preinfo": "Pre-Information Form",
  "pricing.legal.distance": "Distance Sales Agreement",
  "pricing.legal.and": "and",
  "pricing.legal.accept": ", I have read and accept these documents electronically.",
  "pricing.legal.required": "Please accept the Pre-Information Form and Distance Sales Agreement first.",

  // Tools — geo-checkup
  "tools.geo.title": "AI Visibility Checkup",
  "tools.geo.subtitle": "Is your brand visible in ChatGPT, Perplexity and Gemini? Fill the form below and get a detailed report in 30 seconds.",
  "tools.geo.field.sirket": "Company name",
  "tools.geo.field.url": "Website URL",
  "tools.geo.field.sektor": "Sector",
  "tools.geo.field.market": "Target market",
  "tools.geo.field.aciklama": "Short description",
  "tools.geo.field.aciklama.hint": "Optional — describe what you do in 1-2 sentences",
  "tools.geo.field.rivals": "Your competitors",
  "tools.geo.field.rivals.hint": "Up to 5 competitors",
  "tools.geo.field.rivals.placeholder": "Competitor name or URL",
  "tools.geo.field.rivals.add": "Add competitor",
  "tools.geo.submit": "Start analysis",
  "tools.geo.submitting": "AI is analyzing...",
  "tools.geo.hint.duration": "AI response may take ~20-40 seconds.",
  "tools.geo.required.sirket": "Company name is required",
  "tools.geo.fail": "Analysis failed. Please try again.",
  "tools.geo.result.score": "Overall score",
  "tools.geo.result.subscores": "Sub-scores",
  "tools.geo.result.subscore.ai": "AI visibility",
  "tools.geo.result.subscore.tech": "Technical readiness",
  "tools.geo.result.subscore.content": "Content readiness",
  "tools.geo.result.subscore.schema": "Schema",
  "tools.geo.result.subscore.brand": "Brand authority",
  "tools.geo.result.tech": "Technical findings",
  "tools.geo.result.content": "Content findings",
  "tools.geo.result.brand": "Authority findings",
  "tools.geo.result.wins": "Quick wins",
  "tools.geo.result.critical": "Critical issues",
  "tools.geo.result.roadmap": "30 / 60 / 90 day roadmap",
  "tools.geo.result.roadmap.30": "30 days",
  "tools.geo.result.roadmap.60": "60 days",
  "tools.geo.result.roadmap.90": "90 days",
  "tools.geo.result.impact": "Impact:",

  // Tools — competitor radar
  "tools.comp.title": "Competitor Radar",
  "tools.comp.subtitle": "Enter your store and competitors' data. AI generates a comparative analysis, insights and action plan for you.",
  "tools.comp.section.mine": "Your store",
  "tools.comp.section.rivals": "Competitors",
  "tools.comp.platform": "Platform",
  "tools.comp.field.name": "Store name",
  "tools.comp.field.url": "Store URL",
  "tools.comp.field.revenue": "Monthly revenue (₺)",
  "tools.comp.field.orders": "Monthly orders",
  "tools.comp.field.rating": "Seller rating",
  "tools.comp.field.cancel": "Cancellation rate (%)",
  "tools.comp.field.followers": "Followers",
  "tools.comp.field.products": "Products",
  "tools.comp.field.price": "Avg. price (₺)",
  "tools.comp.field.shipping": "Shipping time (days)",
  "tools.comp.field.rival.urls": "Competitor URLs",
  "tools.comp.field.rival.urls.hint": "Up to 5 competitors",
  "tools.comp.field.rival.urls.add": "Add competitor",
  "tools.comp.hint.rivals": "The fields below are competitor averages (you can enter estimates).",
  "tools.comp.field.rival.rating": "Competitor rating (avg.)",
  "tools.comp.field.rival.cancel": "Competitor cancel (%)",
  "tools.comp.field.rival.followers": "Competitor followers",
  "tools.comp.field.rival.products": "Competitor products",
  "tools.comp.field.rival.age": "Competitor age (months)",
  "tools.comp.field.rival.price": "Competitor avg. price (₺)",
  "tools.comp.submit": "Start comparison",
  "tools.comp.required.name": "Store name is required",
  "tools.comp.required.rival": "Add at least 1 competitor URL",
  "tools.comp.fail": "Analysis failed.",
  "tools.comp.result.summary": "Summary",
  "tools.comp.result.strong": "My strengths",
  "tools.comp.result.weak": "My weaknesses",
  "tools.comp.result.compare": "Comparison",
  "tools.comp.result.col.criterion": "Criterion",
  "tools.comp.result.col.mine": "Mine",
  "tools.comp.result.col.rival": "Rival",
  "tools.comp.result.col.status": "Status",
  "tools.comp.result.insights": "Insights",
  "tools.comp.result.actions": "Action items",
  "tools.comp.result.impact": "Impact:",

  // Tools — report analytics
  "tools.rapor.title": "Report Analytics",
  "tools.rapor.subtitle": "Upload your marketplace seller report (CSV / text) or paste the data. AI summarizes it and surfaces opportunities.",
  "tools.rapor.platform": "Platform",
  "tools.rapor.files": "Report files",
  "tools.rapor.files.hint": "CSV / TXT format, up to 5 files. First 8000 characters of each are analyzed.",
  "tools.rapor.files.btn": "Select file (CSV / TXT)",
  "tools.rapor.paste": "Or paste the data",
  "tools.rapor.paste.hint": "Table, text or short summary is accepted.",
  "tools.rapor.paste.placeholder": "E.g.: Month: Oct 2024 — Net revenue: $124,000 — Orders: 520 — Cancel rate: 8.2% — Rating: 4.7 ...",
  "tools.rapor.submit": "Analyze report",
  "tools.rapor.fail": "Analysis failed.",
  "tools.rapor.required": "Please upload or paste report data first.",
  "tools.rapor.read_fail": "could not be read",
  "tools.rapor.strong": "Strengths",
  "tools.rapor.weak": "Weaknesses",
  "tools.rapor.products": "Product performance",
  "tools.rapor.alerts": "Alerts",
  "tools.rapor.tasks": "Action items",
  "tools.rapor.metric.revenue": "Net revenue",
  "tools.rapor.metric.orders": "Net orders",
  "tools.rapor.metric.cancel": "Cancel rate",
  "tools.rapor.metric.return": "Return rate",
  "tools.rapor.metric.rating": "Seller rating",
  "tools.rapor.metric.followers": "Followers",
  "tools.rapor.metric.basket": "Avg. basket",
  "tools.rapor.metric.commission": "Commission",
  "tools.rapor.col.product": "Product",
  "tools.rapor.col.orders": "Orders",
  "tools.rapor.col.revenue": "Revenue",
  "tools.rapor.col.cancel": "Cancel %",
  "tools.rapor.col.stock": "Stock",
  "tools.rapor.col.status": "Status",

  // Tools — pricing
  "tools.fiyat.title": "Pricing Engine",
  "tools.fiyat.subtitle": "Enter your costs, commission and target margin. Get instant recommended selling prices and real net profit per platform.",
  "tools.fiyat.section.costs": "Costs",
  "tools.fiyat.section.targets": "Targets",
  "tools.fiyat.section.platforms": "Platforms",
  "tools.fiyat.section.results": "Recommended selling prices",
  "tools.fiyat.currency": "Currency",
  "tools.fiyat.product_cost": "Product cost",
  "tools.fiyat.shipping_cost": "Shipping cost",
  "tools.fiyat.packaging_cost": "Packaging",
  "tools.fiyat.marketing_cost": "Marketing / Ads",
  "tools.fiyat.other_cost": "Other costs",
  "tools.fiyat.total": "Total unit cost:",
  "tools.fiyat.margin": "Target profit margin (%)",
  "tools.fiyat.margin.hint": "Profit on cost",
  "tools.fiyat.vat": "VAT (%)",
  "tools.fiyat.commission": "Commission %",
  "tools.fiyat.no_platform": "Select at least one platform.",
  "tools.fiyat.sell_price": "Sell price",
  "tools.fiyat.net_revenue": "Net revenue",
  "tools.fiyat.net_profit": "Net profit",
  "tools.fiyat.real_margin": "Actual margin:",
  "tools.fiyat.formula": "Formula:",

  // Legal
  "legal.kvkk": "Privacy (KVKK)",
  "legal.terms": "Terms of Use",
  "legal.cookies": "Cookie Policy",
  "legal.updated": "Last updated:",

  // Cookie banner
  "cookie.title": "We use cookies",
  "cookie.body": "GrowthRIQ uses essential cookies to function. For details see our",
  "cookie.body.link": "Cookie Policy",
  "cookie.body.suffix": ".",
  "cookie.essential": "Essential only",
  "cookie.accept": "Accept all",

  // Footer
  "footer.tools": "Free tools",
  "footer.blog": "Blog",
  "footer.pricing": "Pricing",
  "footer.col.product": "Product",
  "footer.col.company": "Company",
  "footer.col.legal": "Legal",
  "footer.col.commerce": "Commerce",
  "landing.footer.tagline": "AI-powered e-commerce growth intelligence. Built in Türkiye.",
  "landing.footer.payments": "Secure payments: İyzico · 3D Secure",

  // Getting Started Checklist (Dashboard)
  "checklist.title": "Your getting-started guide",
  "checklist.title.done": "Congrats — setup complete!",
  "checklist.subtitle": "Follow these steps to see your first value in minutes.",
  "checklist.subtitle.done": "You're ready to use GrowthRIQ to its fullest. You can dismiss this card.",
  "checklist.progress": "done",
  "checklist.s1.title": "Account created",
  "checklist.s1.body": "Welcome to GrowthRIQ. You're 5 minutes away from your first score.",
  "checklist.s2.title": "Add your first company",
  "checklist.s2.body": "Sector, business model and target markets sharpen the accuracy of every analysis.",
  "checklist.s2.cta": "Add company",
  "checklist.s3.title": "Try a free tool",
  "checklist.s3.body": "Get instant value in 1 minute with GEO Checkup, Competitor Radar or the Pricing Engine.",
  "checklist.s3.cta": "Open tools",
  "checklist.s4.title": "Complete the full assessment",
  "checklist.s4.body": "A 55-question digital maturity assessment — produces a McKinsey-grade strategic report.",
  "checklist.s4.cta": "Start assessment",
  "checklist.s5.title": "View your strategic report",
  "checklist.s5.body": "Once SWOT, category scores and your 30/60/90 day roadmap are ready, download as PDF.",
  "checklist.s5.cta": "Open report",
  "checklist.s6.title": "Upgrade to Premium",
  "checklist.s6.body": "Unlimited assessments, multi-company support, advanced reports and priority support.",
  "checklist.s6.cta": "See plans",
  "checklist.demo.title": "An empty dashboard is boring, right?",
  "checklist.demo.body": "Load a sample company + completed assessment + AI report with one click. Delete anytime.",
  "checklist.demo.cta": "Load demo data",
  "checklist.demo.loading": "Loading…",
  "checklist.demo.success": "Demo data loaded — take a look around!",
  "checklist.demo.fail": "Could not load demo data. Please try again.",
  "checklist.demo.active": "Demo data active: Sample Textile Co. — this is not real customer data.",
  "checklist.demo.remove": "Remove demo",
  "checklist.demo.removed": "Demo data removed.",

  // Onboarding Tour (common controls)
  "tour.step": "Step",
  "tour.next": "Next",
  "tour.prev": "Back",
  "tour.finish": "Got it, let's start",
  "tour.replay": "Show intro again",
  "tour.dontShowAgain": "Don't show this again",

  // GEO Checkup tour
  "tour.geo.s1.title": "Welcome to AI Visibility Checkup",
  "tour.geo.s1.body": "This tool analyzes how visible your brand is in AI engines like ChatGPT, Perplexity and Gemini in 5 minutes. No signup required.",
  "tour.geo.s2.title": "1) Enter your company details",
  "tour.geo.s2.body": "Pick your company name, sector and target market. Adding your website URL produces a more accurate analysis. A short description helps too.",
  "tour.geo.s3.title": "2) Add up to 5 competitors (optional)",
  "tour.geo.s3.body": "Enter your competitors' domains for a comparative visibility table. Leave empty to only assess your own brand.",
  "tour.geo.s4.title": "3) Read the result and act",
  "tour.geo.s4.body": "You'll get an overall score, sub-scores, critical findings, quick wins and a 30/60/90 day roadmap. Email the result to yourself if you want.",

  // Competitor Radar tour
  "tour.competitor.s1.title": "Welcome to Competitor Radar",
  "tour.competitor.s1.body": "Anonymously benchmark against competitors on Trendyol, Hepsiburada, Amazon, Shopify and more. Spot gaps and opportunities.",
  "tour.competitor.s2.title": "1) Pick a platform and your data",
  "tour.competitor.s2.body": "Choose the platform you compete on. Fill in your store name, average rating, product count, price and follower metrics.",
  "tour.competitor.s3.title": "2) Add competitor(s)",
  "tour.competitor.s3.body": "Provide your rival's core metrics (rating, product count, average price, store age, etc.). More rivals = better analysis.",
  "tour.competitor.s4.title": "3) AI summary, tasks and roadmap",
  "tour.competitor.s4.body": "Get a Win/Lose/Tie table, strengths/weaknesses, threat level, urgent tasks and a 30/60/90 day plan.",

  // Report Analytics tour
  "tour.analytics.s1.title": "Welcome to Report Analytics",
  "tour.analytics.s1.body": "Let AI interpret seller reports you download from Trendyol, Hepsiburada, Amazon, Shopify and more. Data is encrypted and never stored.",
  "tour.analytics.s2.title": "1) Pick your platform",
  "tour.analytics.s2.body": "Select which marketplace the report is from. AI understands platform-specific metrics (commission, return rate, AOV, etc.).",
  "tour.analytics.s3.title": "2) Upload or paste the report",
  "tour.analytics.s3.body": "Drag-and-drop CSV/XLSX files, or paste the table into the text area. Up to 8,000 characters are processed.",
  "tour.analytics.s4.title": "3) Instant AI insights and to-do list",
  "tour.analytics.s4.body": "You'll see category breakdown, campaign ROI, customer profile, critical alerts and a prioritized task list.",

  // Pricing Engine tour
  "tour.pricing.s1.title": "Welcome to Pricing Engine",
  "tour.pricing.s1.body": "Enter your cost, platform commission, shipping and target margin; instantly compute recommended retail prices for every marketplace.",
  "tour.pricing.s2.title": "1) Enter your costs",
  "tour.pricing.s2.body": "Type your unit cost, shipping, packaging and VAT. Make sure to pick the right currency (TRY/USD/EUR/GBP).",
  "tour.pricing.s3.title": "2) Set your target margin",
  "tour.pricing.s3.body": "Specify the gross margin you want (%). This is the anchor of the calculation. ~30% is a sensible starting point in most categories.",
  "tour.pricing.s4.title": "3) Platform-by-platform prices",
  "tour.pricing.s4.body": "Trendyol, Hepsiburada, Amazon, Etsy, Shopify… you'll see recommended retail prices, net revenue and margins per platform.",
};

export default en;
